<div [class]="classes()" [attr.aria-label]="label()">
  <svg class="alert__icon" [ftrIcon]="actualIcon()" [iconSize]="24"></svg>
  @if (renderAsMarkdown()) {
    <span class="alert__message" [attr.role]="role()" markdown [renderAllBreaks]="true">
      <ng-container *ngTemplateOutlet="content" />
    </span>
  } @else {
    <span class="alert__message" [attr.role]="role()">
      <ng-container *ngTemplateOutlet="content" />
    </span>
  }
</div>

<ng-template #content>
  <ng-content />
</ng-template>
